import { Suspense, useEffect } from "react";
import useLazyChunk from "src/ui/hooks/useLazyChunk";

import { ChunkLoadErrorBoundary, lazyChunk } from "@shared/ChunkLoadErrorBoundary";

import type { Props } from "./AddRuleDialog";

const importDialog = () => import("./AddRuleDialog").then((module) => ({ default: module.AddRuleDialog }));

const LazyAddRuleDialog = lazyChunk(importDialog);

export const useAddRuleDialogChunk = () => useLazyChunk(importDialog);

export const usePreloadAddRuleDialog = (enabled: boolean) => {
    useEffect(() => {
        if (enabled) {
            importDialog().catch(() => undefined);
        }
    }, [enabled]);
};

export const AddRuleDialog = (props: Props) => (
    <ChunkLoadErrorBoundary onError={props.toggleDialog}>
        <Suspense fallback={null}>
            <LazyAddRuleDialog {...props} />
        </Suspense>
    </ChunkLoadErrorBoundary>
);
